import { render } from "./customer.vue?vue&type=template&id=5c4f40f6"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"

import "./customer.vue?vue&type=style&index=0&id=5c4f40f6&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__